import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { useNavigate } from 'react-router-dom'
import HeroImg from '../resources/fotosKathi/3.jpg'
import './style/Cart.css'

const Cart = ({ abwesend }) => {
  const [cartItems, setCartItems] = useState([])
  const navigate = useNavigate()

  useEffect(() => {
    const storedCart = JSON.parse(localStorage.getItem('cart')) || []
    setCartItems(storedCart)
  }, [])

  const removeItem = index => {
    //eyyy
    const updatedCart = cartItems.filter((_, i) => i !== index)
    setCartItems(updatedCart)
    localStorage.setItem('cart', JSON.stringify(updatedCart))
  }

  const clearCart = () => {
    setCartItems([])
    localStorage.removeItem('cart')
  }

  const updateQuantity = (index, newQuantity) => {
    const quantity = Math.round(Number(newQuantity))
    if (!Number.isInteger(quantity) || quantity < 1 || quantity > 99) return
    const updatedCart = cartItems.map((item, i) =>
      i === index
        ? {
            ...item,
            selectedOptions: {
              ...item.selectedOptions,
              stueckzahl: quantity
            }
          }
        : item
    )
    setCartItems(updatedCart)
    localStorage.setItem('cart', JSON.stringify(updatedCart))
  }

  const handleBestellen = () => {
    if (abwesend) {
      alert(
        'Der Shop ist zurzeit geschlossen. Bitte versuchen Sie es später erneut.'
      )
    } else {
      navigate('/checkout')
    }
  }

  const berechnePreis = item => {
    const mengeInGramm = parseInt(
      item.selectedOptions.menge.replace('g', ''),
      10
    )
    let aufpreis = 0
    if (mengeInGramm === 250) aufpreis = 1.5
    else if (mengeInGramm === 500) aufpreis = 1.0

    const einzelpreis = (item.price / 1000) * mengeInGramm + aufpreis
    return (einzelpreis * item.selectedOptions.stueckzahl).toFixed(2)
  }

  function capitalizeFirstLetter (string) {
    if (!string) return ''
    return string.charAt(0).toUpperCase() + string.slice(1)
  }

  const cartTotal = cartItems
    .reduce((acc, item) => acc + Number(berechnePreis(item)), 0)
    .toFixed(2)

  return (
    <>
      <div
        className='aktuellesPageImageDiv'
        style={{
          backgroundImage: `url(${HeroImg})`,
          backgroundPosition: 'center'
        }}
      >
        <div className='textDivAktuellesPage'>
          <h1>Warenkorb</h1>
          <p>Hier kannst du deinen Warenkorb bearbeiten.</p>
        </div>
      </div>
      <div className='cart-container'>
        {cartItems.length === 0 ? (
          <div className='cart-empty'>
            <p>Dein Warenkorb ist noch leer.</p>
            <Link to='/produkte' className='cart-checkout-button'>
              Produkte ansehen
            </Link>
          </div>
        ) : (
          <>
            <ul>
              {cartItems.map((item, index) => (
                <li key={index} className='cart-item'>
                  <img
                    src={item.images[0]}
                    alt={item.name}
                    className='cart-item-image'
                  />
                  <div className='cart-item-details'>
                    <h3>{item.name}</h3>
                    <p>
                      {capitalizeFirstLetter(item.selectedOptions.mahlgrad)}
                      {item.selectedOptions.mahlgrad === 'gemahlen'
                        ? ` · ${capitalizeFirstLetter(item.selectedOptions.kaffeeart)}`
                        : ''}
                      {' · '}
                      {item.selectedOptions.menge}
                    </p>

                    <p className='cart-item-price'>{berechnePreis(item)} €</p>
                  </div>
                  <div className='cart-item-actions'>
                    <div className='quantity-stepper'>
                      <button
                        type='button'
                        aria-label='Weniger'
                        disabled={item.selectedOptions.stueckzahl <= 1}
                        onClick={() =>
                          updateQuantity(
                            index,
                            item.selectedOptions.stueckzahl - 1
                          )
                        }
                      >
                        −
                      </button>
                      <span>{item.selectedOptions.stueckzahl}</span>
                      <button
                        type='button'
                        aria-label='Mehr'
                        disabled={item.selectedOptions.stueckzahl >= 99}
                        onClick={() =>
                          updateQuantity(
                            index,
                            item.selectedOptions.stueckzahl + 1
                          )
                        }
                      >
                        +
                      </button>
                    </div>
                    <button
                      className='remove-button'
                      onClick={() => removeItem(index)}
                    >
                      Entfernen
                    </button>
                  </div>
                </li>
              ))}
            </ul>
            <div className='cart-footer'>
              <div className='cart-total-row'>
                <span>Summe</span>
                <strong>{cartTotal} €</strong>
              </div>
              <button
                className='cart-checkout-button'
                onClick={() => handleBestellen()}
                disabled={abwesend}
              >
                {abwesend ? 'Zurzeit geschlossen' : 'Zur Kasse'}
              </button>
              <Link to='/produkte' className='back-to-shop'>
                Weiter einkaufen
              </Link>
            </div>
          </>
        )}
      </div>
    </>
  )
}

export default Cart
